import Pepperoni from '../assets/pepperoni.jpg'
import Margherita from '../assets/margherita.jpg'
import PedroTechSpecial from '../assets/pedrotechspecial.jpg'
import Vegan from '../assets/vegan.jpg'
import Pineapple from '../assets/pineapple.jpg'
import Expensive from '../assets/expensive.jpg'
export const MenuList=[
    {
        name: " Pepperoni Pizz",
        image: Pepperoni,
        price:15.99,
    },
    {
        name: "Margherita Pizza",
        image: Margherita,
        price:11.99,
    },
    {
        name: "PedroTech Special Pizza",
        image: PedroTechSpecial,
        price:25.99,
    },
    {
        name: "Vegan Pizza",
        image: Vegan,
        price:17.99,
    },
    {
        name: "Pineapple Pizza",
        image: Pineapple,
        price:4.99,
    },
    {
        name: "Very Expensive Pizza",
        image: Expensive,
        price:149.99,
    },
]